import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Typography
} from '@material-ui/core';
import { AsyncButton } from '.';

const ConfirmDialog = ({ confirmText, cancelText, content, title, open, onConfirm, onCancel }) => {
  const DialogProps = {
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    maxWidth: 'xs',
    fullWidth: true,
    open
  };

  return (
    <>
      <Dialog {...DialogProps}>
        <DialogTitle id="responsive-dialog-title">
          <Typography variant="h6" className="text-gray-800 text-18 font-semibold tracking-wide">
            {title}
          </Typography>
          {/* Close Icon */}
          <IconButton
            aria-label="close"
            className="absolute right-8 top-6 text-gray-700"
            onClick={onCancel}>
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>

        {/* Dialog Content */}
        <DialogContent dividers className="p-20 text-center">
          <Icon color="error" className="text-60">
            warning
          </Icon>
          <Typography
            color="error"
            variant="subtitle1"
            className="text-16 font-semibold tracking-wide">
            {content}
          </Typography>
        </DialogContent>

        {/* Dialog Action Buttons */}
        <DialogActions className="flex justify-between px-16 py-12">
          <Button variant="contained" onClick={onCancel}>
            {cancelText}
          </Button>
          {/* <Button
            variant="contained"
            className="bg-red-400 text-white hover:bg-red-600"
            onClick={onConfirm}>
            {confirmText}
          </Button> */}
          <AsyncButton
            type="button"
            icon="delete"
            text={confirmText}
            className="bg-red-400 text-white hover:bg-red-600"
            // loading={loading}
            handleClick={onConfirm}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

ConfirmDialog.defaultProps = {
  content: 'Kullanıcıyı silmek istiyorsunuz, emin misiniz?'
};

export default ConfirmDialog;
